import apiServices from 'api_services/request-handler';
import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';
import { setCommonLoading } from '../slices/common-slice';

export const uploadImage = (data: any, onDone) => {
    return async (dispatch: AppDispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.uploadImage,
                setLoading: setCommonLoading,
                param_data: data,
                isSuccessMessage: true,
                onDone: (res: any) => {
                    onDone(res?.data?.data?.[0])
                },
            }),
        );
    };
};